import Navbar from "../common/navbar/navbar";
import FooterSection from "../common/footer/footer";
import { useEffect } from "react";

const TermsAndCondition = ({ history }) => {
    // style variables
    let navHeight = "7.25rem";

    // useEffect(() => {
    //     window.scrollTo({
    //         top: 0,
    //     });
    // }, []);

    // links for top navbar
    const navLinks = [
        <h5
            key="0"
            className="my-0 mx-3 text-1"
            style={{ cursor: "pointer" }}
            onClick={() => {
                history.push("/#how-it-works-section");
            }}
        >
            How it Works
        </h5>,
        <h5
            key="1"
            className="my-0 mx-3 text-1"
            style={{ cursor: "pointer" }}
            onClick={() => {
                history.push("/#company");
            }}
        >
            Company
        </h5>,
        <h5
            key="2"
            className="my-0 mx-3 text-1"
            style={{ cursor: "pointer" }}
            onClick={() => {
                history.push("/#pricing");
            }}
        >
            Pricing
        </h5>,
        <h5
            key="3"
            className="my-0 mx-3 text-1"
            style={{ cursor: "pointer" }}
            onClick={() => {
                history.push("/contact-us");
            }}
        >
            Contact Us
        </h5>,
    ];

    // links for sidebar
    const sidebarLinks = [
        <h5
            key="0"
            className="my-0 mx-3 text-1"
            data-bs-dismiss="offcanvas"
            style={{ cursor: "pointer" }}
            onClick={() => {
                history.push("/#how-it-works-section");
            }}
        >
            How it Works
        </h5>,
        <h5
            key="1"
            className="my-0 mx-3 text-1"
            data-bs-dismiss="offcanvas"
            style={{ cursor: "pointer" }}
            onClick={() => {
                history.push("/#company");
            }}
        >
            Company
        </h5>,
        <h5
            key="2"
            className="my-0 mx-3 text-1"
            data-bs-dismiss="offcanvas"
            style={{ cursor: "pointer" }}
            onClick={() => {
                history.push("/#pricing");
            }}
        >
            Pricing
        </h5>,
        <h5
            key="3"
            className="my-0 mx-3 text-1"
            data-bs-dismiss="offcanvas"
            style={{ cursor: "pointer" }}
            onClick={() => {
                history.push("/contact-us");
            }}
        >
            Contact Us
        </h5>,
    ];

    // links for footer
    const footerLinks = [
        <h5
            key="0"
            className="my-3 text-inverse"
            style={{ cursor: "pointer" }}
            onClick={() => {
                history.push("/#how-it-works-section");
            }}
        >
            How it Works
        </h5>,
        <h5
            key="1"
            className="my-3 text-inverse"
            style={{ cursor: "pointer" }}
            onClick={() => {
                history.push("/#company");
            }}
        >
            Company
        </h5>,
        <h5
            key="2"
            className="my-3 text-inverse"
            style={{ cursor: "pointer" }}
            onClick={() => {
                history.push("/#pricing");
            }}
        >
            Pricing
        </h5>,
        <h5
            key="3"
            className="my-3 text-inverse"
            style={{ cursor: "pointer" }}
            onClick={() => {
                history.push("/contact-us");
            }}
        >
            Contact Us
        </h5>,
    ];

    // action buttons for top navbar
    const navButtons = [
        <button
            style={{ height: "3rem" }}
            onClick={() => {
                history.push("/#free-alerts");
            }}
            className="btn btn-outline-primary rounded-pill text-nowrap px-5 text-btn"
        >
            Free Alerts
        </button>,
        <button
            style={{ height: "3rem" }}
            onClick={() => history.push(CHOOSE_PLAN_ROUTE)}
            className="btn btn-primary rounded-pill text-nowrap text-inverse px-5 text-btn"
        >
            Get Started
        </button>,
    ];

    // action buttons for sidebar
    const sidebarButtons = [
        <button
            style={{ height: "3rem" }}
            onClick={() => {
                history.push("/#free-alerts");
            }}
            className="btn btn-outline-primary rounded-pill text-nowrap px-5 text-btn"
        >
            Free Alerts
        </button>,
        <button
            style={{ height: "3rem" }}
            onClick={() => history.push(CHOOSE_PLAN_ROUTE)}
            className="btn btn-primary rounded-pill text-nowrap text-inverse px-5 text-btn"
        >
            Get Started
        </button>,
    ];

    return (
        <>
            <Navbar
                navHeight={navHeight}
                navButtons={navButtons}
                navLinks={navLinks}
                sidebarButtons={sidebarButtons}
                sidebarLinks={sidebarLinks}
            />
            <main
                className="w-100"
                style={{ marginTop: navHeight, overflowY: "hidden" }}
            >
                <div
                    id="tnc"
                    className="bg-light py-5"
                    style={{ minHeight: `calc(100vh - ${navHeight})` }}
                >
                    <div className="container p-2 mt-0">
                        <div className="content text-2">
                            <h1 className="text-secondary pb-4">
                                Terms and Condition
                            </h1>
                            <section>
                                <h5>ACCEPTANCE OF TERMS</h5>
                                <p>
                                    This site is owned and operated by
                                    Compliance Education & Training Pty Ltd ABN{" "}
                                    <b>25 650 834 905 </b> (<b>the Supplier </b>)
                                </p>
                                <p>
                                    By using the <b>site </b> and the{" "}
                                    <b>services</b>, or by registering as a
                                    user, you (being a{" "}
                                    <b>Sole trader/Partnership/Company </b> )
                                    agree to be bound by the following agreement
                                    between <b>you </b> and <b>us </b>. These{" "}
                                    <b>terms of use </b> govern <b>your </b>{" "}
                                    access to and use of this website ("
                                    <b>site </b>"), and <b>your </b> use of the
                                    facilities, applications, search engines and
                                    other services on the <b>site </b>.
                                    Consideration for entering into this
                                    agreement is represented by your initial
                                    monthly subscription payment. If <b>you </b>{" "}
                                    do not agree to these terms of use, please
                                    exit the <b>site </b> immediately.
                                </p>
                                <p>
                                    <b>We </b> may update these{" "}
                                    <b>terms of use </b> by posting the new
                                    version on the <b>site </b> at any time and
                                    without separate notice to <b>you </b>.{" "}
                                    <b>Your </b> continued use of this{" "}
                                    <b>site </b> or the <b>services </b> after{" "}
                                    <b>we </b> post any changes to these{" "}
                                    <b>terms of use </b> constitutes <b>your </b>{" "}
                                    agreement to those changes from that date.
                                </p>
                                <ul>
                                    <li>
                                        The site and the services are a portal
                                        that allows Real Estate Agents to meet
                                        compliance governance as required by law
                                        under the Property & Stock Agents Act
                                        2002.
                                    </li>
                                    <li>
                                        <b>Our </b> role is limited to operating
                                        the site, displaying information
                                        provided by us and{" "}
                                        <b>content providers</b>, and collecting
                                        user information to facilitate
                                        transactions and access through the{" "}
                                        <b>site </b>
                                    </li>
                                    <li>
                                        By accessing <b>content </b> through the
                                        site, <b>you </b> agree and acknowledge
                                        to conditions imposed by the Supplier
                                        and any relevant <b>content provider </b>
                                        .
                                    </li>
                                    <li>
                                        <b>We </b> are the providers of any of
                                        the <b>compliance materials</b>, and{" "}
                                        <b>
                                            whilst all care and due diligence
                                            has been made in compiling and
                                            providing the materials
                                         </b>
                                        , we do not make any warranties as to
                                        the accuracy or quality of the{" "}
                                        <b>compliance materials </b> nor your use
                                        and application of the compliance
                                        materials or any third-party materials
                                        which may be available on the site from
                                        time to time
                                    </li>
                                </ul>
                            </section>

                            <section>
                                <h5>REGISTERING AS A USER</h5>
                                <ul>
                                    <li>
                                        <b>You </b> must register as a{" "}
                                        <b>user </b> of the <b>site </b> in{" "}
                                        <b>registration </b> to access compliance
                                        materials. Registered <b>users </b> can
                                        represent sole traders, partnerships or
                                        companies.
                                    </li>
                                    <li>
                                        <b>You </b> warrant that the information{" "}
                                        <b>you've </b> supplied to <b>us </b> is
                                        correct and current, and that <b>you </b>{" "}
                                        are over 18 years of age, or if you are
                                        under 18 years of age, that you have
                                        obtained your parent's or guardian's
                                        consent to use the <b>services </b>.
                                    </li>
                                    <li>
                                        <b>You </b> must keep <b>your </b> user id
                                        and password secret. <b>You </b> are
                                        personally responsible for any actions
                                        made by anyone using <b>your </b> user id
                                        and password.
                                    </li>
                                    <li>
                                        The supplier provides the site and
                                        compliance materials for exclusive use
                                        of the customer and their associated
                                        employees. The supplier provides support
                                        services to the customer by way of email
                                        and phone support. The customer
                                        acknowledges that it has, at all times,
                                        in place, sufficient computing hardware,
                                        software and internet connection(s) to
                                        operate the system.
                                    </li>
                                    <li>
                                        Should the customer require onsite
                                        support services (or backend support
                                        services) in order to:
                                        <ol type="a">
                                            <li>
                                                input required data into the
                                                system.
                                            </li>
                                            <li>
                                                update required data as a result
                                                of misuse or{" "}
                                            </li>
                                            <li>
                                                restore a customer’s compliance
                                                records due to mismanagement.
                                                then the customer agrees to pay
                                                the supplier an hourly rate of
                                                $150 per hour billed on Tax
                                                Invoice plus $50 travel expenses
                                                (if warranted)
                                            </li>
                                        </ol>
                                        then the customer agrees to pay the
                                        supplier an hourly rate of $150 per hour
                                        billed on Tax Invoice plus $50 travel
                                        expenses (if warranted)
                                    </li>
                                </ul>
                            </section>

                            <section>
                                <h5>YOUR WARRANTIES AND OBLIGATIONS</h5>
                                <p>
                                    To use the <b>site</b> or the <b>services</b>, you must:
                                </p>
                                <ul>
                                    <li>
                                        comply with these <b>terms of use</b> and all
                                        applicable laws and regulations; and
                                    </li>
                                    <li>
                                        use the <b>site</b> and the <b>services</b> in good
                                        faith and
                                    </li>
                                    <li>
                                        warrant that you have the authority to
                                        bind any sole proprietor, partnership or
                                        company to this agreement
                                    </li>
                                </ul>
                                <p><b>You</b> must not:</p>
                                <ul>
                                    <li>
                                        post or send any material, or do
                                        anything which is unlawful, offensive,
                                        abusive, indecent, defamatory or
                                        menacing, or in breach of any rights of
                                        others;
                                    </li>
                                    <li>
                                        cause annoyance, inconvenience or
                                        needless anxiety to others;
                                    </li>
                                    <li>
                                        post commercial advertisements or
                                        promotional material;
                                    </li>
                                    <li>
                                        collect information (including
                                        information about other users) for
                                        purposes outside these <b>terms of use</b>; or
                                    </li>
                                    <li>
                                        disclose <b>your</b> username or password (if
                                        any) to any other person.
                                    </li>
                                </ul>
                            </section>

                            <section>
                                <h5>INTELLECTUAL PROPERTY RIGHTS</h5>
                                <p>
                                    The material on the <b>site</b> is protected under
                                    Australian and international copyright and
                                    other laws governing protection of
                                    intellectual property rights. <b>you</b> must not
                                    sell, license, rent, modify, distribute,
                                    copy, reproduce, transmit, publicly display,
                                    publicly perform, publish, create derivative
                                    works from, adapt, or edit such materials.
                                    However, <b>you</b> may copy (either electronically
                                    or in hard copy) material on the <b>site</b> only
                                    for non-commercial use in conjunction with
                                    <b>your</b> use of the <b>services</b>.
                                </p>
                            </section>

                            <section>
                                <h5>CONFIDENTIALITY</h5>
                                <p>
                                    The Supplier and the Customer recognise that
                                    this Agreement creates a confidential
                                    relationship between the supplier and the
                                    customer and that information containing
                                    both the suppliers and the customers affairs
                                    within the portal, is confidential in
                                    nature. Neither the supplier or customer,
                                    may, without written consent during the term
                                    of this agreement (or after termination of
                                    the agreement) disclose any personal
                                    information to any person or organisation
                                    about each other, except as required by law.
                                </p>
                            </section>

                            <section>
                                <h5>SUSPENSION/CANCELLATION</h5>
                                <p>
                                    Either party may end this agreement by 30
                                    days written notice at any time. A final
                                    monthly subscription fee will fall due
                                    within the 30-day termination period and you
                                    agree not to withhold the final payment due
                                    to the supplier. <b>We</b> reserve the right to
                                    suspend or cancel <b>your registration</b> at any
                                    time if:
                                </p>
                                <ul>
                                    <li>
                                        <b>you</b> are in breach of any term of this
                                        agreement, or any policies applicable to
                                        users of the <b>site</b>;
                                    </li>
                                    <li>
                                        <b>we</b> cannot verify, or we reasonably
                                        believe information <b>you</b> have provided to
                                        us is false, inaccurate or outdated;
                                    </li>
                                    <li>
                                        <b>you</b> do anything which in our reasonable
                                        opinion is illegal, unethical or there
                                        is suspicious activity on <b>your</b> account.
                                    </li>
                                </ul>
                                <p>
                                    On cancellation of <b>your registration</b> for any
                                    cause:
                                </p>
                                <ul>
                                    <li>
                                        <b>We</b> may at our discretion delete all data
                                        associated with <b>your</b> account once all
                                        binding transactions are completed post
                                        termination;
                                    </li>
                                    <li>
                                        <b>We</b> will not be liable for any costs,
                                        losses or damages of any kind arising as
                                        a consequence of terminating <b>your</b> access
                                        to the <b>site</b> or deleting <b>your</b> account
                                        data. Nothing in these terms and
                                        conditions excludes or restricts or
                                        modifies any of <b>your</b> statutory or
                                        contractual rights against the supplier
                                        or any <b>content provider</b>.
                                    </li>
                                </ul>
                            </section>

                            <section>
                                <h5>DISCLAIMERS AND LIMITATION OF LIABILITY</h5>
                                <p>
                                    <b>You </b> use the <b>site </b> and{" "}
                                    <b>services </b> at <b>your </b> sole risk.
                                    Any arrangements made between <b>you </b> and
                                    any third-party provider named on or
                                    referred by the <b>site </b> is at{" "}
                                    <b>your </b> sole risk and responsibility.
                                    The <b>site </b> contains general information
                                    and material from many different sources.{" "}
                                    <b>We </b> make no representation and do not
                                    warrant that the general information
                                    provided on the <b>site </b> is complete,
                                    accurate or current
                                </p>
                                <ul>
                                    <li>
                                        Our sole obligation under this agreement
                                        is to use our best endeavours to operate
                                        and update the site, to facilitate{" "}
                                        <b>your  </b> 
                                        access to updated{" "}
                                        <b> compliance materials  </b>
                                        and keep <b>you </b> informed of any
                                        changes in legislation that may affect{" "}
                                        <b>your  </b> 
                                        compliance status.{" "}
                                    </li>
                                    <li>
                                        In no event shall <b>we </b> be liable
                                        for any claims or damages including any
                                        indirect, special or consequential
                                        damages or injury to any person or
                                        corporation in respect of: any 
                                        <b> compliance materials</b>, including,
                                        but not limited to, claims for faulty
                                        design or manufacture, negligent or
                                        advice, or damages arising from loss or
                                        use of the 
                                        <b> compliance materials </b> ; or any
                                        delay or interruption in <b>your  </b>{" "}
                                        access to the site either by war, act of
                                        God or civil disturbance. any action or
                                        inaction of the supplier or{" "}
                                        <b>content provider </b> or other{" "}
                                        <b>user </b> of the <b>site </b>.
                                    </li>
                                </ul>

                                <p>
                                    THE INFORMATION, SERVICES AND MATERIAL
                                    CONTAINED IN THIS <b>SITE </b> ARE PROVIDED
                                    ON AN "AS IS" BASIS. TO THE MAXIMUM EXTENT
                                    PERMITTED BY LAW, <b>WE </b> DISCLAIM ALL
                                    REPRESENTATIONS AND WARRANTIES, EXPRESS OR
                                    IMPLIED, WITH RESPECT TO SUCH INFORMATION,
                                    SERVICES AND MATERIALS, WHETHER PROVIDED BY
                                    US, THIRD PARTY CONTRACTORS OR OTHER USERS.
                                    NEITHER <b>WE </b> NOR ANY OF <b>OUR </b>{" "}
                                    DIRECTORS, EMPLOYEES, CONTRACTORS OR OTHER
                                    REPRESENTATIVES, WILL BE LIABLE FOR ANY
                                    LOSS, DAMAGE OR PERSONAL INJURY WHATSOEVER
                                    WHICH MAY ARISE OUT OF OR IN CONNECTION WITH
                                    <b> YOUR </b> USE OF THIS <b>SITE </b> OR THE
                                    SERVICES, TO THE MAXIMUM EXTENT PERMITTED BY
                                    LAW. <br />
                                    THIS LIMITATION OF LIABILITY EXTENDS TO
                                    LOSS, DAMAGE OR PERSONAL INJURY CAUSED
                                    DIRECTLY OR INDIRECTLY BY <b>YOUR </b> ACCESS
                                    TO OR INABILITY TO ACCESS THIS <b>SITE </b>{" "}
                                    OR THE SERVICES, AND <b>YOUR </b>
                                    RELIANCE ON ANY INFORMATION PROVIDED IN THE
                                    <b> SITE</b>, EVEN IF <b>WE </b> HAVE BEEN
                                    ADVISED OF THE POSSIBILITY OF SUCH DAMAGES
                                    OR INJURY.
                                </p>
                            </section>

                            <section>
                                <h5>INDEMNITY</h5>
                                <p>
                                    <b>YOU </b> AGREE TO INDEMNIFY, AND HOLD
                                    HARMLESS <b>US  </b>
                                    AND <b>OUR </b> DIRECTORS, EMPLOYEES,
                                    CONTRACTORS OR OTHER REPRESENTATIVES FROM
                                    ALL LIABILITIES, CLAIMS AND EXPENSES,
                                    INCLUDING LEGAL FEES THAT ARISE FROM{" "}
                                    <b>YOUR </b> USE OR MISUSE OF THIS
                                    <b>SITE </b> OR THE <b>SERVICES</b>, ANY{" "}
                                    <b>COMPLIANCE MATERIALS</b>, OR ANY DISPUTE{" "}
                                    <b>YOU </b> HAVE WITH A CONTENT PROVIDER OR
                                    ANOTHER USER OF THE
                                    <b> SITE </b>. WHERE APPLICABLE <b>WE </b>{" "}
                                    RESERVE THE RIGHT, AT <b>OUR </b> OWN
                                    EXPENSE, TO ASSUME THE EXCLUSIVE DEFENCE AND
                                    CONTROL OF ANY MATTER OTHERWISE SUBJECT TO
                                    INDEMNIFICATION BY <b>YOU</b>, IN WHICH
                                    EVENT <b>YOU </b> WILL COOPERATE WITH{" "}
                                    <b>US </b> IN ASSERTING ANY AVAILABLE
                                    DEFENCES.
                                </p>
                            </section>
                        </div>
                    </div>
                </div>
            </main>
            <FooterSection links={footerLinks} />
        </>
    );
};

export default TermsAndCondition;
